import { render, staticRenderFns } from "./IOSBarcode.vue?vue&type=template&id=0c55b9c8&scoped=true"
import script from "./IOSBarcode.vue?vue&type=script&lang=js"
export * from "./IOSBarcode.vue?vue&type=script&lang=js"
import style0 from "./IOSBarcode.vue?vue&type=style&index=0&id=0c55b9c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c55b9c8",
  null
  
)

export default component.exports